import { render, staticRenderFns } from "./WhatsAppActionForm.vue?vue&type=template&id=5f5d22c9&scoped=true&"
import script from "./WhatsAppActionForm.vue?vue&type=script&lang=js&"
export * from "./WhatsAppActionForm.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppActionForm.vue?vue&type=style&index=0&id=5f5d22c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d22c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCheckbox,VIcon,VSelect,VSwitch})
